import { FunCollectionService } from './../common-functions/fun-collection.service';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { MultiLangService } from '../../dataservices/master-service/multi-lang.service';
import { WEBINAR_CONSENT_POPUP_OBJECT } from '../../constants/app.constants';

@Component({
  selector: 'app-action-modal',
  templateUrl: './action-modal.component.html',
  styleUrls: ['./action-modal.component.scss']
})
export class ActionModalComponent implements OnInit, OnChanges {
  @Output() resetActionModal = new EventEmitter();
  @Output() shareClick = new EventEmitter();
  @Input() isActionModalShown: boolean;
  @Input() actionData;
  @Input() isActionModalHeaderShown = true;
  info_msg = '';
  title = '';
  description = '';

  constructor(public mls: MultiLangService, private fcs: FunCollectionService) { }

  ngOnInit(): void {
    for (let i = 0; i < this.actionData.param.length; i++) {
      if (this.actionData.param[i].key == 'description') {
        this.description = this.actionData.param[i].value;
      }

      if (this.actionData.param[i].key == 'title') {
        this.title = this.actionData.param[i].value;
      }
    }
  }

  ngOnChanges(): void {

    if (this.isActionModalShown == true) {
      if (this.info_msg == '' || this.info_msg == null) {
        this.info_msg = 'Oops Something went wrong';
      }
      this.showModal();
    }
  }

  resetInfoMsgModal(): void {
    this.resetActionModal.emit(false);
  }


  showModal(): void {
    this.isActionModalShown = true;

  }

  hideModal(): void {
    this.isActionModalShown = false;
    this.resetInfoMsgModal();
  }

  onHidden(): void {
    this.isActionModalShown = false;
    this.resetInfoMsgModal();
  }


  resetModal(result): void {
    this.resetActionModal.emit(result);
  }


  actionModal(targetData): void {
    if (targetData.type === 'close') {
      this.shareClick.emit(true);
    }
    if (targetData.url === '' && targetData.id === '' && (targetData.type === '' || targetData.type === 'close')) {
      this.isActionModalShown = false;
      this.resetActionModal.emit(false);
    } else if ((targetData.url == '') && (targetData.id != '' || targetData.type != '')) {
      if (targetData.type === 'webinar') {
        this.fcs.navigateToWebinarDetail(targetData.id);
      } else if (targetData.type === 'event') {
        this.fcs.navigateToEventDetail(targetData.id);
      } else if (targetData.type === 'cme') {
        this.fcs.navigateToCmeDetail(targetData.id);
      } else if (targetData.type === 'channel') {
        this.fcs.navigateToChannelDetail(targetData.id);
      } else if (targetData.type === WEBINAR_CONSENT_POPUP_OBJECT.SHOW_WEBINAR_CONSENT_POPUP_KEY) {
        this.resetActionModal.emit({ [WEBINAR_CONSENT_POPUP_OBJECT.SHOW_WEBINAR_CONSENT_POPUP_KEY]: WEBINAR_CONSENT_POPUP_OBJECT.SHOW_WEBINAR_CONSENT_POPUP_TRUE, id: targetData.id });
      }
    } else if (targetData.type === 'link') {
      window.open(targetData.url, '_self');
    } else if (targetData.url != '' && targetData.type == '') {
      //  console.log('redirect on new window');
      window.open(targetData.url, '_blank');
    }
  }
}
